import { List } from 'immutable'
import { Record } from '../transit'
import ImageNote from './ImageNote'

const Result = new Record({
  _id: null,
  driverId: '',
  driver: null,
  driverFirstName: '',
  driverLastName: '',
  driverNameSearch: '',
  driverBirthdate: null,
  driverEmploymentFinished: false,
  companyId: '',
  companyName: '',
  companyNameSort: '',
  companyArchived: false,
  company: null,
  locationId: '',
  locationName: '',
  locationNameSort: '',
  location: null,
  courseType: '',
  vehicleType: '',
  trafficRulesTestPoints: null,
  trafficRulesTestResult: '',
  psychologicalReport: '',
  drivingLicenceProvided: false,
  drivingLicenceExpireDate: null,
  drivingLicenceNote: '',
  experienceYearsCount: '',
  workExperienceYearsCount: '',
  causedCrashesCount: 0,
  causedCrashesDescription: '',
  notCausedCrashesCount: 0,
  notCausedCrashesDescription: '',
  trafficRulesMistakes: '',
  trafficRulesNotes: new List(),
  trafficRulesPoints: 0,
  drivingTechniqueMistakes: '',
  drivingTechniqueNotes: new List(),
  drivingTechniquePoints: 0,
  defensiveDrivingMistakes: '',
  defensiveDrivingNotes: new List(),
  defensiveDrivingPoints: 0,
  drivingEconomyMistakes: '',
  drivingEconomyNotes: new List(),
  drivingEconomyPoints: 0,
  driverSummary: '',
  recommendationForDriver: '',
  recommendationForCompany: '',
  driverSummaryNote: '',
  recommendationForDriverNote: '',
  recommendationForCompanyNote: '',
  comment: '',
  commentNote: '',
  summary: '',
  result: '',
  riskFactor: 0,
  safetyFactor: 0,

  testedAt: null,
  testedByInstructorAt: null,
  closedByInstructor: false,
  closedByInstructorAt: null,
  closedBySupervisor: false,
  closedBySupervisorAt: null,
  psychologicalReportBy: null,
  trafficRulesTestedBy: null,
  testedBy: null,
  supervisedBy: null,
  archived: false,
  archivedAt: null,
  certificate: '',
  protocol: '',
}, 'result')

const convertImageNotes = (imageNotesArray) => new List(
  imageNotesArray.map((note) => new ImageNote(note)),
)

Result.fromJS = (json) => {
  const resultData = json
  resultData.trafficRulesNotes = convertImageNotes(json.trafficRulesNotes)
  resultData.drivingTechniqueNotes = convertImageNotes(json.drivingTechniqueNotes)
  resultData.defensiveDrivingNotes = convertImageNotes(json.defensiveDrivingNotes)
  resultData.drivingEconomyNotes = convertImageNotes(json.drivingEconomyNotes)
  return new Result(resultData)
}

export default Result



// WEBPACK FOOTER //
// ./src/common/results/Result.js